import { createActions } from "@thewebops/admin-panel";

const actions = {
  downloadImportTemplate: createActions(`gcp/downloadImportTemplate`),
};

export default actions;
